module.exports = __webpack_public_path__ + "media/menu.1104b543.mp4";